<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2> بازیگران فیلم : {{name}}</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-8">
                        <div class="row">
                            <div class="col-6 col-lg-6">
                                <div class="form__group">
                                    <treeselect v-model="selected_cat"
                                                :multiple="false"
                                                :normalizer="normalizer_language"
                                                :options="cast_categories"/>

                                </div>
                            </div>

                            <div class="col-6 col-lg-6">
                                <div class="form__group">
                                    <treeselect v-model="selected_person"
                                                :multiple="false"

                                                :normalizer="normalizer_language"
                                                :async="true"
                                                :loadOptions="load_persons"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>
                        <template #person="{item}">
                            <td>
                                <div class="main__table-text" >{{item.cast.name}}</div>
                            </td>
                        </template>
                        <template #person_cat="{item}">
                            <td>
                                <div class="main__table-text" >{{item.category.name}}</div>
                            </td>
                        </template>
                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">
                                  <div @click="edit_item(item)" datas="#"
                                       class="main__table-btn main__table-btn--edit">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                    </svg>
                                  </div>

                                    <div @click="delete_data(item)" datas="#modal-delete"
                                         class="main__table-btn main__table-btn--delete open-modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import ImageSelector from "@/views/CustomComponent/ImageSelector";
    import Treeselect, {ASYNC_SEARCH} from 'vue3-treeselect'
    import 'vue3-treeselect/dist/vue3-treeselect.css'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    export default {
        name: 'HelloWorld',
        data() {
            return {
                cast_categories: [],
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'person', label: 'شخص'},
                    {key: 'person_cat', label: 'عنوان'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                selected_cat: null,
                name: '',
                selected_person:null,
                load_persons({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('search', searchQuery);

                            axios.post('search_cast_persons', formData, {show_pros: true}).then(function (response) {
                                options = response.data;
                                callback(null, options);
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });

                        })
                    }
                },
                file: null,
                file_preview: null,
                normalizer_language(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
            }
        },
        components: {
            Datatable,
            ImageSelector,
            Treeselect
        },
        mounted() {
            this.get_cast_category();
            this.get_data();
        },
        methods: {
            edit_item(item) {
                this.link = item.link;
                this.status_form = item.id;
            },
            get_data() {

                var self = this;

                var formData = new FormData();
                formData.append('movie_id', this.$route.params.movie_id);

                this.axios.post('get_poster_cast', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_cast_category() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_cast_categories', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.cast_categories = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;

                var formData = new FormData();
                var url = 'insert_poster_cast'
                formData.append('cast_category', this.selected_cat);
                formData.append('poster_id', this.$route.params.movie_id);
                formData.append('cast', this.selected_person);

                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.status_form = 0;
                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
            delete_data(item) {

                var self = this;

                var formData = new FormData();
                var url = 'delete_poster_cast'
                formData.append('poster_id', this.$route.params.movie_id);
                formData.append('id', item.id);

                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.file =null
                    self.status_form = 0;

                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

